import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import SapLoading from "../components/SapLoading";
import BillingLapsedAlert from "../components/BillingLapsedAlert";
import { Footer, TopNav, MainContent, SideNav } from "./index";
import { selectSessionUser, setAuthUser } from "../features/auth/auth.slice";
import { setAppInitialized, setIsMobile } from "../app/core-slice";
import { authService } from "../features/auth/auth.service";
import PrivateRoute from "../components/PrivateRoute";
import { RootState } from "../app/store";

function detectMobile() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

export default function MainLayout() {
    const appInitialized = useAppSelector((state: RootState) => state.core.appInitialized);
    const sessionUser = useAppSelector(selectSessionUser);

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setIsMobile(detectMobile()));

        const user = authService.extractAuthUserFromToken();

        dispatch(setAuthUser(user));
        dispatch(setAppInitialized(true));
    }, []);

    if (!appInitialized) return <SapLoading />;

    return (
        <>
            <TopNav />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <BillingLapsedAlert />
                    <PrivateRoute>
                        <MainContent />
                    </PrivateRoute>
                    <Footer />
                </div>
            </div>
        </>
    );
}
